/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Level2OuterPageLoading } from "@octopusdeploy/design-system-components";
import type { LinkHref } from "@octopusdeploy/portal-routes";
import { links } from "@octopusdeploy/portal-routes";
import type { DataBaseComponentState } from "~/components/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent";
import { createErrorInfoFromErrors } from "~/components/PageContent/createErrorInfo";
import { repository } from "../../clientInstance";
import InternalRedirect from "../../components/Navigation/InternalRedirect/InternalRedirect";
interface DeploymentToProjectTaskRedirectProps {
    spaceId: string;
    deploymentId: string;
}
interface DeploymentToProjectTaskRedirectState extends DataBaseComponentState {
    redirectTo: LinkHref;
}
export default class DeploymentToProjectTaskRedirect extends DataBaseComponent<DeploymentToProjectTaskRedirectProps, DeploymentToProjectTaskRedirectState> {
    constructor(props: DeploymentToProjectTaskRedirectProps) {
        super(props);
        this.state = {
            redirectTo: null!,
        };
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const deploymentId = this.props.deploymentId;
            const deployment = await repository.Deployments.get(deploymentId);
            const release = await repository.Releases.get(deployment.ReleaseId);
            const path = links.deploymentPage.generateUrl({ spaceId: this.props.spaceId, projectSlug: release.ProjectId, releaseVersion: release.Version, deploymentId: deployment.Id });
            this.setState({
                redirectTo: path,
            });
        });
    }
    render() {
        const redirectTo = this.state.redirectTo;
        const errorInfo = this.errors ? createErrorInfoFromErrors(this.errors) : undefined;
        if (!redirectTo) {
            return (<main>
                    <Level2OuterPageLoading errors={errorInfo}/>
                </main>);
        }
        return <InternalRedirect push={false} to={redirectTo}/>;
    }
    static displayName = "DeploymentToProjectTaskRedirect";
}
